// extracted by mini-css-extract-plugin
export default {"topImage":"Pg_1_6_topImage__xxLvv"};